class Purifier {
  constructor (name, fullname, id, webpage, cadr, roomsize, hepaLifespan, weight, power) {
    this.name = name
    if (fullname === null) {
      this.fullname = this.name + ' Air Purifier'
    } else {
      this.fullname = fullname
    }
    this.id = id
    this.webpage = 'https://smartairfilters.com/en/product' + webpage
    this.roomsize = roomsize
    this.cadr = cadr
    this.hepaLifespan = hepaLifespan // in hours
    this.weight = weight // in kg
    this.power = power // on high, in W
  }

  getImg () {
    return require('@/assets/purifiers/' + this.id + '.jpg')
  }

  detailPage () {
    return '/purifiers/' + this.id + '/'
  }
}

//                              Name long name slug   shop url             CADR roomsize HEPA lifespan weight power
export var diy = new Purifier('DIY1.1', null, 'diy11', '/diy-1-1-air-purifier/', 94, 15, 1000, 1.55, 36)

// export var cannon = new Purifier('Cannon', null, 'cannon', '/cannon-diy-air-purifier/', 131, 30, 750, 5.4, 65)

export var blastmini = new Purifier('Blast Mini', 'Blast Mini FFU Air Purifier', 'blastmini', '/blast-mini-ffu/', 585, 85, 2700, 26, 82)

export var sqair = new Purifier('Sqair', null, 'sqair', '/sqair-air-purifier/', 315, 40, 1000, 4, 38)
export var sqairCarbon = new Purifier('Sqair - Chemical Warfare', null, 'sqair_carbon', '/the-sqair-chemical-warfare/', 315, 40, 1000, 4, 38)

export var blast = new Purifier('Blast', 'Blast FFU Air Purifier', 'blast', '/blast-ffu/', 890, 130, 2800, 38, 88)

export var all = [diy, sqair, sqairCarbon, blastmini, blast]



// WEBPACK FOOTER //
// ./src/data/purifiers.js